import React from 'react';
import { CircularProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CircularProgressProps } from '@mui/material/CircularProgress';

interface CircularLoaderProps extends CircularProgressProps {}

const useStyles = makeStyles()(theme => ({
  root: {
    color: theme.palette.grey['700'],
  },
}));

const CircularLoader = (props: CircularLoaderProps) => {
  const { size } = props;
  const { classes } = useStyles();
  return (
    <CircularProgress
      className={classes.root}
      variant="indeterminate"
      color="inherit"
      size={size ?? 24}
      {...props}
    />
  );
};

export default CircularLoader;
